exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".assets-container.padding[data-v-b9e4dbb2]{padding-bottom:12rem}@media (max-width:767px){.assets-container.padding[data-v-b9e4dbb2]{padding-bottom:14rem}}", ""]);

// exports
